import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  ExpansionPanel,
  ExpansionPanelActionEvent,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import RippleButton from "../../components/common/RippleButton";
import {
  clearInquiryDetails,
  clearInquiryFilterDetails,
  setactiveTabIndex,
  setInquiryFilterDetails,
} from "./inquirySlice";
import ButtonForAll from "../../components/common/ButtonForAll";
import { getAllActiveLeadSource } from "../leadsource/services/leadsource.service";
import { ILeadSource } from "../leadsource/leadsourceModel";
import FormDatePicker from "../../components/formFields/FormDateField";
import moment from "moment";
import { ILeadStage } from "../leadstage/leadStageModel";
import { IUser } from "../user/userModel";
// import FormCheckbox from "../../components/formFields/FormCheckbox";
import FormSliderField from "../../components/formFields/FormSliderField";
import FormRangeSliderField from "../../components/formFields/FormRangeSliderField";
import IconComponent from "../../components/common/IconComponent";
import { FaFilter } from "react-icons/fa";
import { Button } from "@progress/kendo-react-buttons";
import { useLocation } from "react-router-dom";
import { ICity } from "../city/cityModel";
import { getAllActiveCities } from "../city/services/city.services";
import { INQUIRYQUERIES, INQUIRYTYPE } from "../../_contstants/common";
import { getAllActiveSectors } from "../sector/services/sector.services";
import { ISector } from "../sector/sectorModel";

// interface ChangeWatcherProps {
//   formRenderProps: FormRenderProps;
// }

// const LeasStageChangeWatcher: React.FC<ChangeWatcherProps> = ({
//   formRenderProps,
// }) => {
//   const dispatch = useAppDispatch();
//   const activeTabIndex = useAppSelector(
//     (state) => state.inquiry.activeTabIndex
//   );
//   const filterInquiryStageID = formRenderProps.valueGetter("filterInquiryStageID");
//   useEffect(() => {
//     if (filterInquiryStageID === 1 || filterInquiryStageID === 2) {
//       dispatch(
//         setactiveTabIndex(
//           filterInquiryStageID === 1 ? 0 : filterInquiryStageID === 2 ? 1 : null
//         )
//       );
//     }
//   }, [filterInquiryStageID]);
//   return null;
// };

const InquiryFilter: React.FC = () => {
  // const gridRef = useRef<any>(null);
  const BTNRef = useRef<any>(null);

  const dispatch = useAppDispatch();
  const location = useLocation();
  const LeadID = location.state?.LeadID;
  const ContactID = location.state?.ContactID;

  const loading = useAppSelector((state) => state.inquiry.loading);
  const UserList = useAppSelector((state) => state.user.UserList);
  const [expand, setExpand] = useState("");
  const InquiryFilterDetails = useAppSelector(
    (state) => state.inquiry.InquiryFilterDetails
  );
  const LeadSourceList = useAppSelector(
    (state) => state.leadsource.LeadSourceList
  );
  const LeadStageList = useAppSelector(
    (state) => state.leadStage.LeadStageList
  );
  const activeTabIndex = useAppSelector(
    (state) => state.inquiry.activeTabIndex
  );
  const CityList = useAppSelector((state) => state.city.CityList);
  const SectorList = useAppSelector((state) => state.sector.SectorList);

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [InquiryFilterDetails]);

  useEffect(() => {
    dispatch(getAllActiveCities());
    dispatch(getAllActiveSectors());
    dispatch(getAllActiveLeadSource());

    if (
      (ContactID && !InquiryFilterDetails?.filterContactID) ||
      (LeadID && !InquiryFilterDetails?.filterLeadID)
    )
      dispatch(
        setInquiryFilterDetails({
          ...InquiryFilterDetails,
          filterFromDate: InquiryFilterDetails?.filterFromDate
            ? moment(
                InquiryFilterDetails?.filterFromDate,
                "YYYY-MM-DD"
              )?.toDate()
            : "",
          filterToDate: InquiryFilterDetails?.filterToDate
            ? moment(InquiryFilterDetails?.filterToDate, "YYYY-MM-DD")?.toDate()
            : "",
          filterContactID: `${ContactID || ""}`,
          filterLeadID: `${LeadID || ""}`,
        })
      );

    return () => {
      dispatch(clearInquiryDetails());
    };
  }, [InquiryFilterDetails?.filterLeadID]);

  const handleSubmit = async (values: any) => {
    const insertPayload = {
      filterContactID: values?.filterContactID
        ? `${values?.filterContactID}`
        : "",
      filterLeadID: values?.filterLeadID ? `${values?.filterLeadID}` : "",
      filterNoOfNights: values?.filterNoOfNights
        ? +values?.filterNoOfNights
        : null,
      filterCity: values?.filterCity ? +values?.filterCity : null,
      filterGoingfrom: values?.filterGoingfrom ? values?.filterGoingfrom : "",
      filterTypeofInquiry: values?.filterTypeofInquiry
        ? values?.filterTypeofInquiry
        : "",
      filterRequirementType: values?.filterRequirementType
        ? values?.filterRequirementType
        : "",
      filterDestination: values?.filterDestination
        ? +values?.filterDestination
        : null,
      filterInquiryStageID: values?.filterInquiryStageID
        ? +values?.filterInquiryStageID
        : null,
      filterInquirySourceID: values?.filterInquirySourceID
        ? +values?.filterInquirySourceID
        : null,
      filterName: values?.filterName ? values?.filterName : "",
      filterIsNew: values?.filterIsNew ? values?.filterIsNew : false,
      filterMobileNo: values?.filterMobileNo ? `${values?.filterMobileNo}` : "",
      filterEmailID: values?.filterEmailID ? values?.filterEmailID : "",
      filterAssignedTo: values?.filterAssignedTo
        ? +values?.filterAssignedTo
        : null,
      filterUnassignedLeads: values?.filterUnassignedLeads
        ? values?.filterUnassignedLeads
        : false,
      filterFromDate: values?.filterFromDate
        ? moment(values?.filterFromDate)?.format("YYYY-MM-DD")
        : "",
      filterToDate: values?.filterToDate
        ? moment(values?.filterToDate)?.format("YYYY-MM-DD")
        : "",
      filterFromBudget: values?.Budget ? values?.Budget?.start : 0,
      filterToBudget: values?.Budget ? values?.Budget?.end : 0,
      Budget: values?.Budget,
    };
    if (
      values?.filterInquiryStageID === 8 ||
      values?.filterInquiryStageID === 4 ||
      values?.filterInquiryStageID === 5 ||
      values?.filterInquiryStageID === 6
    ) {
      dispatch(
        setactiveTabIndex(
          values?.filterInquiryStageID === 8
            ? 4
            : values?.filterInquiryStageID === 4
            ? 3
            : values?.filterInquiryStageID === 5
            ? 5
            : values?.filterInquiryStageID === 6
            ? 6
            : null
        )
      );
    }
    setExpand("");
    dispatch(
      setInquiryFilterDetails({
        ...insertPayload,
        filterIsRecent: values?.filterInquiryStageID
          ? false
          : InquiryFilterDetails?.filterIsRecent,
      })
    );
  };

  return (
    <>
      {/* {loading && <LoadingPanel gridRef={gridRef} />} */}

      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={{
          ...InquiryFilterDetails,
          filterFromDate: InquiryFilterDetails?.filterFromDate
            ? moment(
                InquiryFilterDetails?.filterFromDate,
                "YYYY-MM-DD"
              )?.toDate()
            : "",
          filterToDate: InquiryFilterDetails?.filterToDate
            ? moment(InquiryFilterDetails?.filterToDate, "YYYY-MM-DD")?.toDate()
            : "",
        }}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ExpansionPanel
              className="inquiry-filter-panel m-0"
              title={
                <div>
                  <div>
                    <IconComponent icon={FaFilter} /> Filter Results
                  </div>
                </div>
              }
              expanded={expand === "filter"}
              tabIndex={1}
              onAction={(event: ExpansionPanelActionEvent) => {
                const nativeEvent = event.nativeEvent as KeyboardEvent;
                const ActiveBTN = document.activeElement as HTMLElement;

                if (
                  nativeEvent.type === "keydown" &&
                  nativeEvent.code === "Space"
                ) {
                  nativeEvent.preventDefault();
                  return;
                } else if (
                  nativeEvent.code === "Enter" ||
                  nativeEvent.code === "NumpadEnter"
                ) {
                  nativeEvent.preventDefault();
                  if (ActiveBTN.id === "InquirySubmitBtn") {
                    BTNRef.current.element.click();
                  } else if (ActiveBTN.id === "ClearInquiryDetail") {
                    setExpand("");
                  }
                  return;
                }

                if (event?.expanded) {
                  setExpand("");
                } else {
                  setExpand("filter");
                }
              }}
            >
              {expand === "filter" && (
                <GridLayout
                  style={{ marginRight: 20, padding: 10 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      id={"filterInquiryStageID"}
                      name={"filterInquiryStageID"}
                      label={"Inquiry stage"}
                      placeholder="Inquiry stage"
                      disabled={
                        activeTabIndex === 3 ||
                        activeTabIndex === 4 ||
                        activeTabIndex === 5 ||
                        activeTabIndex === 6
                      }
                      component={FormSelectionField}
                      options={LeadStageList?.map((leadstage: ILeadStage) => {
                        return {
                          value: leadstage?.ID,
                          label: leadstage?.LeadStage,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      id={"filterInquirySourceID"}
                      name={"filterInquirySourceID"}
                      label={"Inquiry Source"}
                      placeholder="Inquiry Source"
                      component={FormSelectionField}
                      options={LeadSourceList?.map(
                        (leadsource: ILeadSource) => {
                          return {
                            value: leadsource?.ID,
                            label: leadsource?.Source,
                          };
                        }
                      )}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="filterName"
                      label="Customer Name"
                      placeholder="Customer Name"
                      maxLength="100"
                      component={FormTextField}
                      onKeyDown={(e: any) => {
                        if (e.key === " ") {
                          formRenderProps.onChange("filterName", {
                            value: `${e?.target?.value} `,
                          });
                        }
                      }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="filterMobileNo"
                      label="Mobile No"
                      type="number"
                      placeholder="i.e. 9999999999"
                      max={10}
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="filterEmailID"
                      label="Email ID"
                      placeholder="i.e. example@gmail.com"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="filterAssignedTo"
                      label="Assigned To"
                      placeholder="assigned To"
                      component={FormSelectionField}
                      options={UserList?.map((user: IUser) => ({
                        value: user?.ID,
                        label: `${user?.FirstName} ${user?.LastName}`,
                      }))}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={"filterFromDate"}
                      label="From Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      disabled={activeTabIndex === 1}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={"filterToDate"}
                      label="To Date"
                      format="dd/MM/yyyy"
                      disabled={!formRenderProps.valueGetter("filterFromDate")}
                      component={FormDatePicker}
                      minDate={moment(
                        formRenderProps.valueGetter("filterFromDate")
                      ).toDate()}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      id={"filterRequirementType"}
                      name={"filterRequirementType"}
                      label={"Type"}
                      placeholder="Requirement Type"
                      component={FormSelectionField}
                      options={INQUIRYQUERIES?.map((type: any) => {
                        return {
                          value: type?.value,
                          label: type?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  {formRenderProps.valueGetter("filterRequirementType") ===
                    "FLIGHT" && (
                    <>
                      <GridLayoutItem>
                        <Field
                          wrapperClassName="w-100"
                          id={"filterCity"}
                          name={"filterCity"}
                          label={"Destination"}
                          placeholder="Destination"
                          component={FormSelectionField}
                          options={CityList?.map((city: ICity) => {
                            return {
                              value: city?.ID,
                              label: city?.CityName,
                            };
                          })}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={2}></GridLayoutItem>
                    </>
                  )}
                  {formRenderProps.valueGetter("filterRequirementType") ===
                    "PACKAGE" && (
                    <>
                      <GridLayoutItem>
                        <Field
                          wrapperClassName="w-100"
                          id={"filterDestination"}
                          name={"filterDestination"}
                          label={"Destination"}
                          placeholder="Destination"
                          component={FormSelectionField}
                          options={SectorList?.map((sector: ISector) => {
                            return {
                              value: sector?.ID,
                              label: sector?.SectorName,
                            };
                          })}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          name="filterGoingfrom"
                          label="Pickup Place"
                          placeholder="i.e. Ahmedabad"
                          component={FormTextField}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={1}></GridLayoutItem>
                    </>
                  )}
                  <GridLayoutItem>
                    <Field
                      name="filterNoOfNights"
                      label="No Of Nights"
                      component={FormSliderField}
                      min={0}
                      max={20}
                      step={1}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id="Budget"
                      name="Budget"
                      label="Budget"
                      component={FormRangeSliderField}
                      min={0}
                      max={100000}
                      step={1}
                    />
                  </GridLayoutItem>
                  {/* <GridLayoutItem>
                    <Field
                      wrapperStyle={{ marginTop: 35 }}
                      name="filterUnassignedLeads"
                      label="Un-Assigned"
                      placeholder="Un-Assigned"
                      component={FormCheckbox}
                    />
                  </GridLayoutItem> */}
                  <GridLayoutItem>
                    <Field
                      name={"filterTypeofInquiry"}
                      label={"Type of Inquiry"}
                      placeholder="i.e. B2B"
                      component={FormSelectionField}
                      options={INQUIRYTYPE?.map((initial: any) => {
                        return {
                          value: initial?.value,
                          label: initial?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={3}
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "end",
                      marginTop: 20,
                    }}
                  >
                    <RippleButton
                      id={"ClearContactDetail"}
                      type="button"
                      fillMode="outline"
                      themeColor="error"
                      style={{ marginRight: 10 }}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        dispatch(clearInquiryFilterDetails());
                      }}
                    >
                      Clear
                    </RippleButton>
                    <ButtonForAll
                      id={"InquirySubmitBtn"}
                      label={"Filter"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                    />

                    <RippleButton
                      id={"ClearInquiryDetail"}
                      type="button"
                      fillMode="outline"
                      themeColor="primary"
                      style={{ marginLeft: 10 }}
                      onClick={() => setExpand("")}
                    >
                      Cancel
                    </RippleButton>
                  </GridLayoutItem>
                </GridLayout>
              )}
            </ExpansionPanel>
            {
              <Button
                style={{ opacity: 0, position: "absolute", left: -50 }}
                ref={BTNRef}
                type="submit"
                disabled={!formRenderProps.allowSubmit || loading}
              >
                Filter
              </Button>
            }
          </FormElement>
        )}
      />
    </>
  );
};

export default InquiryFilter;
